import React, { FC } from "react";
import { faSpinner } from "@fortawesome/pro-regular-svg-icons/faSpinner";
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";

export const Spinner: FC<Omit<FontAwesomeIconProps, "icon">> = (props) => (
  <FontAwesomeIcon icon={faSpinner} {...props} />
);
